import React from "react";
import { PaymentHubAPI } from "../../../providers/PaymentHubAPI";
import { Button } from "../../components/Button";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Loading } from "../../components/Loading";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import { Message } from "../../components/Message";
import { Context } from "pages/Integrations";
import { EnvironmentsAPI } from "../../../providers/EnvironmentsAPI";
import { Checkbox } from "../../components/Checkbox";
import { PaymentMethodConflictWarning } from "../../components/PaymentMethodConflictWarning";
import styles from "@styles/integrations.module.scss";
import { CPF } from "../../tools/CPF";
import { CNPJ } from "../../tools/CNPJ";
import { Phone } from "../../tools/Phone";

const SUPPORTED_CATEGORIES = ["PIX"];
const CATEGORY_LABELS = {
      PIX: "Pix",
     
};

export class WooviDrawer extends React.Component {
    state = {
        loading: false,
        savingOptions: false,
        token: null,
        webhook_url: null,
        accountId: null,
        paymentMethods: {},
        savingPaymentMethod: false,
        localPaymentMethods: {},
        initialPaymentMethods: {},
        lastActivatedMethod: null,
        name: "",
        lastname: "",
        cnpj: "",
        cpf: "",
        phone: "",
        email: ""
    }

    async setAsyncState(data) {
        return new Promise((resolve) => this.setState(data, resolve));
    }

    removeCountryCode(phone) {
        if (!phone) return phone;
        const cleaned = phone.replace(/\D/g, '');
        if (cleaned.startsWith('55') && cleaned.length === 13) {
            return cleaned.substring(2); 
        }
        return phone;
    }

    async componentDidMount() {
        try {
            await this.setAsyncState({ loading: true });
            const selectedEnvironment = await EnvironmentStorage.getSelectedEnvironment();
            await PaymentHubAPI.initAccount();
            const wooviGateway = await PaymentHubAPI.getGatewayConfiguration(selectedEnvironment, `woovi`);
            const accountId = await PaymentHubAPI.getAccountId(selectedEnvironment);
            const paymenthub = await EnvironmentsAPI.getConfigurationsByAlias(selectedEnvironment, 'paymenthub');
            
            const localPaymentMethods = {};
            SUPPORTED_CATEGORIES.forEach(cat => {
                localPaymentMethods[cat] = (paymenthub?.paymentMethods?.[cat] === "woovi");
            });

            this.setState({
                accountId: accountId,
                token: wooviGateway.token,
                webhook_url: wooviGateway.webhook?.url || "",
                paymentMethods: paymenthub?.paymentMethods || {},
                localPaymentMethods: localPaymentMethods,
                initialPaymentMethods: { ...(paymenthub?.paymentMethods || {}) },
                name: wooviGateway.name || "",
                lastname: wooviGateway.lastname || "",
                cnpj: wooviGateway.cnpj || "",
                cpf: wooviGateway.cpf || "",
                phone: this.removeCountryCode(wooviGateway.phone) || "",
                email: wooviGateway.email || ""
            });
            await this.setAsyncState({ loading: false });
        } catch (err) {
            await this.setAsyncState({ loading: false });
        }
    }

    async savePaymentMethod(category, checked) {
        this.setState({ savingPaymentMethod: true });
        const selectedEnvironment = await EnvironmentStorage.getSelectedEnvironment();
        const paymenthub = await EnvironmentsAPI.getConfigurationsByAlias(selectedEnvironment, 'paymenthub');
        const newPaymentMethods = { ...paymenthub?.paymentMethods, [category]: checked ? "woovi" : "pagarme" };
        paymenthub.paymentMethods = newPaymentMethods;
        await EnvironmentsAPI.putConfigurationsByAlias(selectedEnvironment, 'paymenthub', paymenthub);
        this.setState({ paymentMethods: newPaymentMethods, savingPaymentMethod: false });
    }

    handlePaymentMethodCheckbox = (cat, checked) => {
        this.setState((prevState) => {
            const wasChecked = prevState.localPaymentMethods[cat];
            const willBeChecked = checked;
            let lastActivatedMethod = null;
            if (!wasChecked && willBeChecked) {
                lastActivatedMethod = cat;
            }
            return {
                localPaymentMethods: {
                    ...prevState.localPaymentMethods,
                    [cat]: checked
                },
                lastActivatedMethod
            };
        });
    }

    async onSave() {
        try {
            const { onSave } = this.props;
            const { token, webhook_url, localPaymentMethods, name, lastname, cnpj, cpf, phone, email } = this.state;
            await this.setAsyncState({ savingOptions: true });
            const selectedEnvironment = await EnvironmentStorage.getSelectedEnvironment();
            const paymenthub = await EnvironmentsAPI.getConfigurationsByAlias(selectedEnvironment, 'paymenthub');
            const currentPaymentMethods = paymenthub?.paymentMethods || {};

            const localPixChecked = localPaymentMethods?.PIX;

            const updatedPaymentMethods = {
                ...currentPaymentMethods,
                PIX: localPixChecked ? "woovi" : currentPaymentMethods.PIX,
                MONEY: localPixChecked ? "woovi" : currentPaymentMethods.MONEY,
            };
            
            paymenthub.paymentMethods = updatedPaymentMethods;
            await EnvironmentsAPI.putConfigurationsByAlias(selectedEnvironment, 'paymenthub', paymenthub);
            const body = {
                name,
                lastname,
                cnpj: CNPJ.unmask(cnpj),
                cpf: CPF.unmask(cpf),
                phone: Phone.toInternationalNumber(phone),
                email,
                token: token,
                apiKey: "",
                webhook: {
                    name: "Webhook woovi",
                    url: webhook_url,
                    isActive: true
                },
                paymentMethods: updatedPaymentMethods
            };
            const response = await PaymentHubAPI.setGatewayConfiguration(selectedEnvironment, `woovi`, body);
            await this.setAsyncState({ savingOptions: false });
            if (response.getErrors([]).length === 0) {
                onSave && onSave();
            } else {
                alert({ text: `Não foi possível salvar as credenciais: ${response.getErrors()[0]}` });
            }
        } catch (e) {
            await this.setAsyncState({ savingOptions: false });
        }
    }

    render() {
        const { visible, onClose } = this.props;
        const { token, webhook_url, savingOptions, loading, accountId, localPaymentMethods } = this.state;
        return (
            <Drawer
                visible={visible}
                onClose={onClose}
                closeInFade
                title={"Integração - Woovi"}
                footer={
                    <Button
                        design="primary"
                        className="w-100"
                        onClick={this.onSave.bind(this)}
                        loading={savingOptions}
                        disabled={loading || savingOptions}
                    >
                        Salvar alterações
                    </Button>
                }
            >
                <Context />
                {loading ? (
                    <div className="d-flex justify-center align-center h-100">
                        <Loading fullScreen />
                    </div>
                ) : (
                    <div className={styles.scrollContainer}>
                        <Input
                            design="two"
                            className="mb-20"
                            floatLabel="Nome"
                            value={this.state.name}
                            onChange={(e) => this.setState({ name: e.target.value })}
                        />
                        <Input
                            design="two"
                            className="mb-20"
                            floatLabel="Sobrenome"
                            value={this.state.lastname}
                            onChange={(e) => this.setState({ lastname: e.target.value })}
                        />
                        <Input
                            design="two"
                            className="mb-20"
                            floatLabel="CNPJ"
                            value={CNPJ.mask(this.state.cnpj)}
                            onChange={(e) => this.setState({ cnpj: CNPJ.unmask(e.target.value) })}
                        />
                        <Input
                            design="two"
                            className="mb-20"
                            floatLabel="CPF"
                            value={CPF.mask(this.state.cpf)}
                            onChange={(e) => this.setState({ cpf: CPF.unmask(e.target.value) })}
                        />
                        <Input
                            design="two"
                            className="mb-20"
                            floatLabel="Telefone"
                            value={Phone.mask(this.state.phone)}
                            onChange={(e) => this.setState({ phone: e.target.value })}
                        />
                        <Input
                            design="two"
                            className="mb-20"
                            floatLabel="E-mail"
                            value={this.state.email}
                            onChange={(e) => this.setState({ email: e.target.value })}
                        />
                        
                        <Input
                            design="two"
                            className="mb-20"
                            floatLabel="URL do webhook"
                            value={webhook_url}
                            onChange={(e) => this.setState({ webhook_url: e.target.value })}
                        />
                        <Message className="mt-20">
                            <p>
                                Configure o webhook no painel da Woovi com a URL informada abaixo.
                            </p>
                            <br />
                            <p>
                                https://api.food.olga.tech/payment-hub/webhook/distributed/{accountId}/woovi
                            </p>
                        </Message>
                        <div className={styles.box}>
                            <p className={styles.subtitle}>
                                Métodos de pagamento disponíveis
                            </p>
                            <PaymentMethodConflictWarning
                                supportedCategories={SUPPORTED_CATEGORIES}
                                localPaymentMethods={localPaymentMethods}
                                initialPaymentMethods={this.state.initialPaymentMethods}
                                lastActivatedMethod={this.state.lastActivatedMethod}
                                categoryLabels={CATEGORY_LABELS}
                                integrationName="Woovi"
                                gatewayName="woovi"
                            />
                            {SUPPORTED_CATEGORIES.map((cat) => (
                                <div key={cat} className={styles.paymentMethodRow}>
                                    <Checkbox
                                        checked={localPaymentMethods[cat] || false}
                                        onChange={(checked) => this.handlePaymentMethodCheckbox(cat, checked)}
                                        label={CATEGORY_LABELS[cat]}
                                        name={`woovi-method-${cat}`}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </Drawer>
        );
    }
} 